import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { t } from "../i18n";
import { staticPath } from "../data";
import { initAnalytics } from "../lib/analytics";

const KEY = "bc-consent";

export default function CookieConsent({ lang }) {
  const [visible, setVisible] = useState(false);
  const i = t[lang];

  useEffect(() => {
    if (!window.localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const choose = (value) => {
    window.localStorage.setItem(KEY, value);
    setVisible(false);
    if (value === "granted") initAnalytics();
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={i.cookie.title}
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] p-4 sm:p-6"
    >
      <div className="mx-auto flex max-w-3xl flex-col gap-4 rounded-2xl border border-border bg-white p-5 shadow-2xl sm:flex-row sm:items-center">
        <div className="flex items-start gap-3">
          <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-ember" aria-hidden="true" />
          <div>
            <p className="font-display text-sm font-bold">{i.cookie.title}</p>
            <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
              {i.cookie.text}{" "}
              <Link to={staticPath(lang, "cookies")} data-testid="cookie-policy-link" className="font-semibold text-petrol underline-offset-2 hover:underline">
                {i.cookie.policy}
              </Link>
            </p>
          </div>
        </div>
        <div className="flex shrink-0 gap-2 sm:ml-auto">
          <button
            data-testid="cookie-reject"
            onClick={() => choose("denied")}
            className="rounded-full border border-border px-4 py-2 text-xs font-semibold transition-colors duration-200 hover:border-foreground"
          >
            {i.cookie.reject}
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => choose("granted")}
            className="rounded-full bg-petrol px-4 py-2 text-xs font-semibold text-white transition-colors duration-200 hover:bg-petrol-dark"
          >
            {i.cookie.accept}
          </button>
        </div>
      </div>
    </div>
  );
}
